import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout'
import {inject, Service, signal} from '@angular/core'

@Service()
export class OrientationService {
  /**
   * Property to track if the screen is large
   */
  public isSmallScreen = signal(false)

  private readonly breakpointObserver = inject(BreakpointObserver)

  /**
   * Used to dynamically respond to changes in screen size using the
   * BreakpointObserver instance. Maybe also should use Breakpoints.TabletLandscape
   */
  constructor() {
    this.breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait,
      Breakpoints.TabletPortrait
    ]).subscribe(r => this.isSmallScreen.set(r.matches))
  }
}
